import { SectionNamesType } from "@/entities/faq/types";

export const CREATE_PROD_ORDER_DEADLINE = 10;
export const MONTH_NAMES_RU = [
  "январь",
  "февраль",
  "март",
  "апрель",
  "май",
  "июнь",
  "июль",
  "август",
  "сентябрь",
  "октябрь",
  "ноябрь",
  "декабрь",
];
export const sectionNames: Record<SectionNamesType, string> = {
  nomenclature: "Номенклатура",
  basket: "Корзина",
  dealers: "Дилер",
  order: "Заказы",
  remains: "Остатки",
  report: "Отчетность",
  options: "Настройки",
};
